<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES89UC3']['0'] }}
          </h3>
        </div>

        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="detail-block">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['20'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['30'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['40'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.codcomp1 }}-{{ detail.tab1.codcomp2 }}-{{ detail.tab1.codcomp3 }}-{{ detail.tab1.codcomp4 }}-{{ detail.tab1.codcomp5 }}-{{ detail.tab1.codcomp6 }}-{{ detail.tab1.codcomp7 }} - {{ detail.tab1.desc_codcomp}}
          
                      </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['50'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="coddesc_codpos" name="coddesc_codpos">{{ detail.tab1.codpos }} - {{ detail.tab1.desc_codpos }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="numreqst" name="numreqst">{{ detail.tab1.numreqst }}</div>
                  </div>
                </div>
              </div>

              <div class="detail-block-float detail-block-left">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['70'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="coddesc_codjob" name="coddesc_codjob">{{ detail.tab1.codjob }} - {{ detail.tab1.desc_codjob }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['90'] }}</div>
                  <div class="detail-right">
                     <div class="detail-text width-70" id="coddesc_codempmt" name="coddesc_codempmt">{{ detail.tab1.codempmt }} - {{ detail.tab1.desc_codempmt }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['110'] }}</div>
                  <div class="detail-right">
                      <div class="input-group width-70">
                          <input type="text" disabled="disabled" class="form-control input-text" id="qtydatrqyr" name="qtydatrqyr" v-model="detail.tab1.qtydatrqyr" />
                          <div class="input-group-addon input-group-addon-cust">{{ labels['HRES89UC3']['120'] }}</div>
                      </div>
                      <div class="input-group width-70">
                          <input type="text" disabled="disabled" class="form-control input-text" id="qtydatrqmth" name="qtydatrqmth" v-model="detail.tab1.qtydatrqmth" />
                          <div class="input-group-addon input-group-addon-cust">{{ labels['HRES89UC3']['130'] }}</div>
                      </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['140'] }}</div>
                  <div class="detail-right">
                      <div class="input-group width-70">
                          <input type="text" disabled="disabled" class="form-control input-text" id="amtincom" name="amtincom" v-model="detail.tab1.amtincom" />
                          <div class="input-group-addon input-group-addon-cust">{{ labels['HRES89UC3']['150'] }}</div>
                      </div>
                  <div class="text-error" id="form-errors-p_amtwidrw"></div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['160'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="desc_codrearq" name="desc_codrearq">{{ detail.tab1.desc_codrearq }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['170'] }}</div>
                  <div class="detail-right">
                    <input type="radio" value="I" v-model="detail.tab1.flgrecut" disabled="disabled" /> <span class="radio-text">{{ labels['HRES89UC3']['180'] }}</span>
                    <input type="radio" value="E" v-model="detail.tab1.flgrecut" disabled="disabled" /> <span class="radio-text">{{ labels['HRES89UC3']['190'] }}</span>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['200'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70 txtarea-width response-full-width" id="desnote" name="desnote">{{ detail.tab1.desnote }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['210'] }}</div>
                  <div class="detail-right">
                      <input type="checkbox" v-model="flgjob"  disabled="disabled" />
                      {{ labels['HRES89UC3']['220'] }}
                      <br>
                      <div class="detail-text width-70 txtarea-width response-full-width" id="syncond1" name="syncond1">{{ detail.tab1.syncond1 }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left"> </div>
                  <div class="detail-right">
                      <input type="checkbox" v-model="flgcond" disabled="disabled" />
                      {{ labels['HRES89UC3']['230'] }}
                      <br>
                      <div class="detail-text width-70 txtarea-width response-full-width" id="syncond2" name="syncond2">{{ detail.tab1.syncond2 }}</div>
                  </div>
                </div>
              </div>

              <div class="detail-block-float detail-block-right">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['80'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="qtyreq" name="qtyreq">{{ detail.tab1.qtyreq }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES89UC3']['100'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dtereqm" name="dtereqm">{{ setDateOutput(detail.tab1.dtereqm) }}</div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres89u-detail',
  data () {
    return {
      flgjob: false,
      flgcond: false
    }
  },
  watch: {
    'detail.tab1.flgjob' (newVal) {
      this.flgjob = (newVal === 'Y')
    },
    'detail.tab1.flgcond' (newVal) {
      this.flgcond = (newVal === 'Y')
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'data', 'nowLang' ]
}
</script>



// WEBPACK FOOTER //
// detail.vue?74932403